<template>
  <div class="mt-6 p-lg-6 p-3">
    <h3 class="text-secondary font-weight-light text-center">{{ $t("common.welcome_screen.account_set_up_finished") }} 🍾</h3>
    <button @click="finish" class="btn btn-sm btn-primary mt-4 ">{{ $t("common.welcome_screen.start_with_emika") }} <i class="fe fe-arrow-right"></i></button>
  </div>
</template>

<script>
  export default {
    name: 'FinishStep',
    methods: {
      finish: function () {
        window.location.href = '/';
      },
    },
  };
</script>

<style scoped>

</style>
